import { render, staticRenderFns } from "./StoryStatisticViewItem.vue?vue&type=template&id=0eda7ffe&scoped=true&"
import script from "./StoryStatisticViewItem.vue?vue&type=script&lang=ts&"
export * from "./StoryStatisticViewItem.vue?vue&type=script&lang=ts&"
import style0 from "./StoryStatisticViewItem.vue?vue&type=style&index=0&id=0eda7ffe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eda7ffe",
  null
  
)

export default component.exports